import { types } from 'mobx-state-tree';

const EditableCellsNames = [
  'title',
  "sourceItemCode",
  'salePrice',
  'templateId',
  'status',
  'strategyBreakEven',
  'strategyInPercents',
  'strategyProfit',
  'profit',
  'profitInPercents',
  'quantity',
  'monitoringStatus'
]
export const Cell = types.model('Cell', {
  op: types.optional(types.string, 'replace'),
  path: types.optional(types.string, ''),
  value: types.union(types.string, types.undefined, types.number, types.boolean),
  fieldKey: types.optional(types.string, ''),
});

export const EditableCells = types
  .model('EditableCells', {
    title: types.optional(Cell, { path: '/title', fieldKey: 'title' }),
    sourceItemCode: types.optional(Cell, { path: '/sourceItemCode', fieldKey: 'sourceItemCode' }),
    salePrice: types.optional(Cell, { path: '/pricingstrategy/salePrice', fieldKey: 'pricingStrategy.salePrice' }),
    templateId: types.optional(Cell, { path: '/templateId', fieldKey: 'templateId' }),
    status: types.optional(Cell, { path: '/status', fieldKey: 'status' }),
    monitoringStatus: types.optional(Cell, { path: '/monitoringstate/ismonitored', fieldKey: 'monitoringStatus' }),
    strategyBreakEven: types.optional(Cell, { path: '/pricingstrategy/strategyBreakEven', fieldKey: 'pricingStrategy.strategyBreakEven' }),
    strategyInPercents: types.optional(Cell, { path: '/pricingstrategy/strategyInPercents', fieldKey: 'pricingStrategy.strategyInPercents' }),
    strategyProfit: types.optional(Cell, { path: '/pricingstrategy/strategyProfit', fieldKey: 'pricingStrategy.strategyProfit' }),
    profit: types.optional(Cell, { path: '/pricingstrategy/profit', fieldKey: 'pricingStrategy.profit' }),
    profitInPercents: types.optional(Cell, { path: '/pricingstrategy/profitInPercents', fieldKey: 'pricingStrategy.profitInPercents' }),
    quantity: types.optional(Cell, { path: '/quantity', fieldKey: 'quantity' }),
  })
  .views(self => ({
    get changedFieldsArray() {
      return EditableCellsNames.map(field=>self[field]).filter(({ value }) => {
        return value !== undefined;
      });
    },
  }))
  .actions(self => ({
    resetEditableCells() {
      const newEditableCellsObj = EditableCells.create({}).toJSON();
      Object.keys(newEditableCellsObj).forEach(key=>{
        self[key] = newEditableCellsObj[key];
      })
      console.log("editable cells empty now")
    },
    getMappedItemValuesToUpdate(item) {
      Object.keys(item).forEach(key => {
        self[key].value = item[key];
      });
      return self.changedFieldsArray;
    },
  }));
